/* eslint-disable no-use-before-define */
import React from 'react'
import { Typography, Box, makeStyles } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  container: {
    display: 'flex',
  },
  value: {
    ...theme.typography.h5,
  },
}))

const LegacySectionView = ({ section, hidden }) => {
  const classes = useStyle()
  if (hidden) {
    return null
  }
  return section.criterias.map((criteria) => (
    <Box key={criteria.name} className={classes.container}>
      <Typography className={classes.name} variant="h4">
        {`${criteria.name} - `}
        <span className={classes.value}>{criteria.value}</span>
      </Typography>
    </Box>
  ))
}

export default LegacySectionView
